export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
            联系我们
          </h2>
          <p className="mt-3 text-foreground-400 text-sm">
            商务合作、内容投稿、问题反馈，欢迎联系我们
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="bg-background-100 border border-background-300/30 rounded-xl p-6 text-center hover:border-primary-500/30 transition-all duration-300 cursor-pointer">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-500/10 mb-4">
              <i className="ri-mail-line text-xl text-primary-400"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-100">商务合作</h3>
            <p className="mt-2 text-xs text-foreground-500">bd@mayivideo.com</p>
            <p className="text-xs text-foreground-600 mt-1">广告投放 · 版权合作 · 品牌联名</p>
          </div>

          <div className="bg-background-100 border border-background-300/30 rounded-xl p-6 text-center hover:border-primary-500/30 transition-all duration-300 cursor-pointer">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-accent-500/10 mb-4">
              <i className="ri-edit-2-line text-xl text-accent-400"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-100">内容投稿</h3>
            <p className="mt-2 text-xs text-foreground-500">submit@mayivideo.com</p>
            <p className="text-xs text-foreground-600 mt-1">影评投稿 · 原创短片 · 专题合作</p>
          </div>

          <div className="bg-background-100 border border-background-300/30 rounded-xl p-6 text-center hover:border-primary-500/30 transition-all duration-300 cursor-pointer">
            <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-secondary-500/10 mb-4">
              <i className="ri-question-answer-line text-xl text-secondary-400"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-100">问题反馈</h3>
            <p className="mt-2 text-xs text-foreground-500">support@mayivideo.com</p>
            <p className="text-xs text-foreground-600 mt-1">播放问题 · 资源报错 · 功能建议</p>
          </div>
        </div>
      </div>
    </section>
  );
}